import React, { useEffect, Fragment } from "react";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";

export const keyValueRenderer = (value, name, values, fieldUpdateHandler) => {
    const defaultVal = Object.keys(values)[0];
    useEffect(() => {
        !value && fieldUpdateHandler(name, defaultVal);
    }, []);
    const options = Object.entries(values).map((entry) => (
        <MenuItem key={entry[0]} value={entry[0]}>
            {entry[0]}
        </MenuItem>
    ));
    return (
        <Fragment>
            <Select
                value={value || defaultVal}
                default={defaultVal}
                onChange={(e) => fieldUpdateHandler(name, e.target.value)}
            >
                {options}
            </Select>
        </Fragment>
    );
};
